export default __webpack_public_path__ + "static/media/logo.eac650cb.png";